package com.qrkontaq.ui.localization

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.compositionLocalOf
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.qrkontaq.utils.Storage
import com.qrkontaq.utils.StorageKeys

@Composable
fun rememberLanguage(): LanguageState {
    val stored = Storage.get(StorageKeys.LANGUAGE)
    val initialLang = Language.fromCode(stored)
    var currentLanguage by remember { mutableStateOf(initialLang) }

    LaunchedEffect(currentLanguage) {
        Storage.save(StorageKeys.LANGUAGE, currentLanguage.code)
    }

    return remember(currentLanguage) {
        LanguageState(
            currentLanguage = currentLanguage,
            strings = currentLanguage.strings,
            onChange = { newLang ->
                currentLanguage = newLang
            }
        )
    }
}

data class LanguageState(
    val currentLanguage: Language,
    val strings: AppStrings,
    val onChange: (Language) -> Unit
)

val LocalLanguageState = compositionLocalOf<LanguageState> {
    error("LanguageState not provided")
}

@Composable
fun ProvideLanguage(
    languageState: LanguageState = rememberLanguage(),
    content: @Composable () -> Unit
) {

    CompositionLocalProvider(
        LocalLanguageState provides languageState,
        LocalAppStrings provides languageState.strings
    ) {
        content()
    }
}
